export * from "./depthRenderer.pure";

import "../Shaders/depth.fragment";
import "../Shaders/depth.vertex";
